<div class="event-card">
    <div class="event-img">
        <img [src]="getEventImage()" alt="" />
    </div>
    <div class="event-info">
        <h3>{{ event?.events_title }}</h3>
        <div class="event-dates">
            <span class="icon-calendar"></span>
            {{ transformEventStartEndDates(event?.events_start_date, event?.events_end_date) }}
        </div>
        <div class="event-time">
            <span class="icon-clock"></span>
            {{ transformTime(event?.events_start_time) }} - {{ transformTime(event?.events_end_time) }}
        </div>
    
        @if (event?.events_info?.events_flyer) {
            <div class="event-document">
                <span class="icon-map"></span>
                <a [href]="getEventFlyer()" target="_blank">Download Flyer</a>
            </div>
        }
    
        @if(event?.events_info?.events_register) {
            <div class="event-register-price">
                <span class="icon-dollar-sign"></span>
                {{ event?.events_info?.events_register?.reg_price }}
            </div>
        }
    
        @if (event?.events_info?.events_location) {
            <div class="event-location">
                <span class="icon-map-pin"></span>
                {{ event?.events_info?.events_location }}
            </div>
        }
    
        @if (event?.events_info?.events_notes) {
            <div class="event-notes">
                <span class="icon-list"></span>
                {{ event?.events_info?.events_notes }}
            </div>
        }

        @if (!hideRegisterArea && (showComingSoon || showRegisterButton)) {
            @if (showComingSoon) {
                <div class="event-reg-info">
                    <span class="icon-bell"></span>
                    Registration Starting {{ transformRegStartDate() }}
                </div>
            }

            @if (showRegisterButton) {
                <div class="event-register">
                    <button class="drc-btn btn-primary" (click)="onClickRegister()">
                        Register
                        <span class="icon-arrow-right"></span>
                    </button>
                </div>
            }
        }
    </div>
</div>
